import { Box, BoxProps } from "@mui/material";
import { FC, SyntheticEvent, useState } from "react";

interface IActionGroupTitleImage extends BoxProps<'img'> {
  fallbackComponent: React.ReactNode;
}

export const ActionGroupTitleImage: FC<IActionGroupTitleImage> = ({
  fallbackComponent,
  ...rest
}) => {
  const [showImage, setShowImage] = useState(true);

  const handleImageError = (_e: SyntheticEvent<HTMLImageElement>) => {
    setShowImage(false);
  }

  return showImage ? 
    <Box
      component="img"
      onErrorCapture={handleImageError}
      {...rest}
    /> 
  :
  fallbackComponent
}